export default "__VITE_ASSET__91d31e72__"